export default __webpack_public_path__ + "7606d9430562a89b8ac68988d832852e.ttf";